
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_3bgfn_1yl3y_93"
};
  